<template>
  <div>

    <vue-headful
      title="foodi.de - Essen online bestellen"
      description="Essen online bestellen - keine Verständnis­probleme, keine Miss­verständ­nisse. Online­zahlung per PayPal, Apple Pay, Google Pay, Sofortüberweisung oder Barzahlung möglich."
      image="https://foodi.de/static/og_image.jpg"
      lang="de"
      ogLocale="de_DE"
      url="https://foodi.de/"
    />

    <div class="phstart-search -m-4 lg:-m-8 p-4" v-bind:style="{ backgroundImage: 'url(/static/' + background + ')' }">
      <h1 class="text-white border-none text-center text-shadow mb-0 mt-6">
        <img class="foodilogo" src="/static/foodi-shadow.svg" title="foodi.de - Lieblingsessen online bestellen" alt="foodi.de logo"/>
      </h1>
      <h2 class="text-white border-none text-center text-shadow mb-2 -mt-6">Ort auswählen, Essen aussuchen und bestellen:</h2>

      <v-select label="item_ort_einfach" aria-label="PLZ oder Ort eingeben" :filterable="false" :options="options" @search="onSearch" @input="setlocation" placeholder="Deine PLZ / Wohnort" tabindex="1">
        <template slot="spinner"></template>
        <template slot="no-options">
          Gib deine Postleitzahl oder deinen Wohnort ein
        </template>
        <template slot="option" slot-scope="option">
          {{ option.item_plz }} {{ option.item_ort_einfach }}
          <span v-if="option.item_ortsteil != '' && option.item_ortsteil != option.item_ort_einfach" class="text-grey-dark">{{ option.item_ortsteil }}</span>
        </template>
        <template slot="selected-option" slot-scope="option">
          Ausgewählt: {{ option.item_plz }} {{ option.item_ort_einfach }}
        </template>
      </v-select>

      <div class="p-6 text-center text-white text-shadow text-xl -mt-2">
        <a v-if="lastLocation.id" v-on:click="setlocation(lastLocation)" class="inline-block my-2 text-white no-underline hover:underline" href="javascript:void(0);" role="button" tabindex="2">Zuletzt gewählt: <strong>{{ lastLocation.item_plz }} {{ lastLocation.item_ort_einfach }}</strong></a>

        <div v-if="isLoggedIn" class="my-8">
          <strong>Gespeicherte Lieferorte:</strong><br />
          <ul class="list-reset">
            <li v-for="location in uniqueUserLocations" :key="location.id">
              <a href="javascript:void(0)" v-on:click="setlocation(location)" class="inline-block my-2 text-white no-underline hover:underline">
                📍 {{ location.item_plz }} {{ location.item_ort_einfach }}
              </a>
            </li>
          </ul>
        </div>

        <router-link tag="a" v-if="archivedOrdersCount > 0" :to="{ name: 'Archiv' }" class="inline-block my-4 text-white no-underline hover:underline">📤 {{ archivedOrdersCount }}+ Bestellungen im Archiv</router-link><br />
        <router-link tag="a" :to="{ name: 'Einstellungen' }" class="inline-block my-4 text-white no-underline hover:underline">💝 Gutscheine für neue Freunde</router-link><br />
        <router-link tag="a" :to="{ name: 'Shop', params: { hostUrl: 'foodi-shop' } }" class="inline-block my-4 text-white no-underline hover:underline">🎁 Geschenkgutscheine kaufen</router-link><br />
        <router-link tag="a" :to="{ name: 'Business' }" class="inline-block my-4 text-white no-underline hover:underline">🏬 Angebote für Firmenkunden</router-link><br />
      </div>
    </div>

    <div class="w-full max-w-3xl xl:mx-auto mt-8 pt-4 bg-white mb-8">
      <h3 class="text-3xl text-center uppercase border-none mb-1 pb-1">Bestell dein Lieblingsessen zu dir nach Hause mit foodi.de</h3>
      <p class="text-center text-lg">
        Einfach Adresse eingeben, Restaurant aussuchen und auf
        <router-link tag="a" :to="{ name: 'Pizza' }" class="text-black">Pizza</router-link>,
        Pasta,
        <router-link tag="a" :to="{ name: 'Burger' }" class="text-black">Burger</router-link>,
        <router-link tag="a" :to="{ name: 'Doener' }" class="text-black">Döner</router-link>,
        Sushi,
        indische Spezialitäten
        und vieles mehr
        freuen.
      </p>
    </div>


    <div class="w-full max-w-3xl xl:mx-auto mt-8 pt-4 bg-white mb-16">
      <h4 class="text-xl border-b-2 border-green-heinz mb-4 text-center uppercase">So einfach geht's!</h4>

      <div class="lg:flex justify-between">

          <div class="lg:mr-3 w-full lg:w-1/4 mb-3 lg:mb-0">
            <img class="order-steps" src="/static/icons/selectfood.png" alt="Essen auswählen und bestellen">
            <p class="font-black mt-1 text-center">Essen auswählen und bestellen</p>
            <p class="mt-1 text-center">Keine Verständnis&shy;probleme, keine Miss&shy;verständ&shy;nisse</p>
          </div>

          <div class="lg:mr-3 w-full lg:w-1/4 mb-3 lg:mb-0">
            <img class="order-steps" src="/static/icons/payment.png" alt="Einfach zahlen">
            <p class="font-black mt-1 text-center">Einfach zahlen</p>
            <p class="mt-1 text-center">Online­zahlung per PayPal, Apple Pay, Google Pay, Sofortüberweisung oder Barzahlung möglich</p>
          </div>

          <div class="lg:mr-3 w-full lg:w-1/4 mb-3 lg:mb-0">
            <img class="order-steps" src="/static/icons/status.png" alt="Statusupdates erhalten">
            <p class="font-black mt-1 text-center">Statusupdates erhalten</p>
            <p class="mt-1 text-center">Erhalte Informationen per WhatsApp oder SMS wann dein Essen fertig ist</p>
          </div>

          <div class="w-full lg:w-1/4">
            <img class="order-steps" src="/static/icons/love.png" alt="Gutes tun">
            <p class="font-black mt-1 text-center">Gutes tun</p>
            <p class="mt-1 text-center">Von jeder Bestellung geht ein Teil an Hilfsorganisationen - guten Appetit!</p>
          </div>

      </div>

    </div>

    <div class="-m-4 lg:-m-8 p-4 pt-8 bg-green-heinz" v-observe-visibility="donationVisible">
      <div class="pb-12">
        <p role="heading" class="text-2xl font-bold text-center uppercase text-white mb-1">Gutes essen ♥ Gutes tun!</p>
        <p class="text-white text-center">Von jeder Bestellung spendet foodi.de einen Teil an Projekte und Hilfsorganisationen.</p>
        <p class="text-white text-center text-lg mt-1">Zuletzt sind jeweils
          <span class="font-black">
            <animated-number
              :value="donationsCount"
              :formatValue="formatDonation"
              :duration="500"
            />
          </span>
          gespendet worden an das Kinder- und Jugendhospiz in Koblenz & an das Tierheim in Ransbach-Baumbach
        </p>

        <transition name="fade" mode="out-in">
          <div class="partnerinfo mb-3 mt-1" v-if="showpartnerinfo">
              <div key="6040" v-if="partner === 'ahrweiler'">
                <p class="text-center bg-white p-1">Auch wir unterstützen die Anwohner des Ahrtals nach den schlimmen Überflutungen. Auch ihr könnt helfen - jeder Cent zählt 💚 Spendenkonto: DE86577513100000339457 (BIC MALADE51AHR) Kontoinhaber: Kreisverwaltung Ahrweiler. Stichwort: Hochwasserhilfe. <a href="https://kreis-ahrweiler.de/spendenkonto-fuer-vom-hochwasser-betroffene" target="_blank" class="text-black">Weitere Details zum Spendenkonto</a></p>
              </div>
          </div>
        </transition>

        <p class="text-white text-center">Jede Bestellung zählt!</p>
      </div>

    </div>


    <div class="-m-4 lg:-m-8 p-4 pt-8 bg-grey-darkest" v-observe-visibility="registrationVisible">
      <div class="pb-12">
        <p role="heading" class="text-2xl font-bold text-center uppercase text-white mb-1 border-none">Restaurant anmelden</p>
        <p class="text-white text-center">Du hast ein Restaurant oder Lieferdienst und möchstest deinen Kunden Onlinebestellungen anbieten?</p>
        <p class="text-white text-center text-lg mt-4 pt-4 pb-4"><router-link :to="{ name: 'Registration' }" tag="a" class="bg-green-heinz p-4 font-black text-white no-underline inline-block">Melde dich an und mach mit!</router-link></p>
        <p class="text-white text-center mt-4">Profitiere von unseren vergünstigten Tarifen bei Onlinezahlung und erhalte Bestellungen über unsere moderne App in Echtzeit.</p>
        <p class="text-white text-center mt-2">Hier erhälst du weitere <router-link tag="a" :to="{ name: 'Informationen' }" class="text-white">Informationen für Anbieter</router-link>.</p>
      </div>
    </div>

    <div class="-m-4 lg:-m-8 p-4 pt-8 bg-white">
      <div class="text-center mt-6">
        <p role="heading" class="text-2xl font-bold border-b-2 border-green-heinz mb-4 ">Dein Lieblingsanbieter fehlt hier?</p>
        <router-link :to="{ name: 'Recommend' }" tag="a" class="text-black no-underline hover:underline">Empfehle uns einen Anbieter und wir versuchen ihn bei uns aufzunehmen!</router-link>
      </div>

    </div>

  </div>
</template>

<script>
import endpoints from '../../endpoints'
import axios from 'axios'
import _ from 'lodash'
import { mapGetters } from 'vuex'
import { mapFields } from 'vuex-map-fields'
import AnimatedNumber from "animated-number-vue";

export default {
  name: 'StartseitePizzaheinz',

  components: {
    AnimatedNumber
  },

  data () {
    return {
      options: [],
      archivedOrdersCount: 0,
      lastLocation: {},
      seoLocations: [],
      seoHosts: [],
      errors: [],
      backgrounds: [
        'foodi-yummy-1.jpg',
        'foodi-yummy-2.jpg',
        'foodi-yummy-3.jpg',
        'foodi-yummy-4.jpg',
        'foodi-yummy-5.jpg',
        'foodi-yummy-6.jpg',
        'foodi-yummy-7.jpg',
        'foodi-yummy-8.jpg',
        'foodi-yummy-9.jpg',
        'foodi-yummy-10.jpg'
      ],
      background: 'foodi-yummy-1.jpg',
      donationsSum: 500,
      donationsCount: 0,
      donationIsCounted: false,
      showpartnerinfo: false,
      partner: '',
      showCoronaSpecial: false
    }
  },

  computed: {
    ...mapGetters([
      'uniqueUserLocations',
      'isLoggedIn'
    ]),

    ...mapFields([
      'content.item_geoid'
    ])
  },

  watch: {

  },

  created () {
    this.getArchivedOrdersCount()
    this.getLastLocation()
    this.getInfos()
    this.getBackground()
  },

  methods: {

    onSearch (search, loading) {
      loading(true)
      this.search(loading, search, this)
    },

    search: _.debounce((loading, search, vm) => {
      axios.post(endpoints.locations, { 'query': search })
        .then(response => {
          vm.options = response.data
          loading(false)
        })
        .catch(e => {
          this.errors.push('Lieferorte konnten nicht geladen werden 😭')
          loading(false)
        })
    }, 200),

    setlocation (val) {
      this.item_geoid = (typeof val.item_geoid !== 'undefined' ? val.item_geoid : val.id)

      axios.post(endpoints.setGeoId, { 'geoid': this.item_geoid })
        .then(response => {
          this.$router.push({
            name: 'Anbieter',
            params: { geoUrl: val.item_url }
          })
        })
        .catch(e => {
          this.errors.push('Lieferort konnten nicht gesetzt werden 😭')
        })
    },

    getArchivedOrdersCount () {
      axios.post(endpoints.archivedOrdersCount, { })
        .then(response => {
          this.archivedOrdersCount = response.data
        })
    },

    getLastLocation () {
      if (Number(this.item_geoid) > 0) {
        axios.post(endpoints.lastlocation, { query: this.item_geoid })
          .then(response => {
            this.lastLocation = response.data
          })
      }
    },

    getInfos () {
      axios.post(endpoints.infos, { })
        .then(response => {
          this.seoLocations = response.data.locations
          this.seoHosts = response.data.hosts
        })
    },

    selectHost (host) {
      window.hostId = host.id

      axios.post(endpoints.sethost + host.id, {})
        .then(response => {
          this.$router.push({ name: 'Shop', params: { hostUrl: host.item_url } })
        })
    },

    // get a random background image from data array
    getBackground() {
      let number = Math.floor(Math.random() * this.backgrounds.length);
      this.background = this.backgrounds[number];
    },

    // toggle visibility of partner information
    togglePartnerInfo(partner) {
      if(this.showpartnerinfo && this.partner === partner) {
        this.showpartnerinfo = false;
        this.partner = '';
      } else {
        this.showpartnerinfo = true;
        this.partner = partner;
      }
    },

    // format the donation sum
    formatDonation(value) {
      return `${Number(value).toFixed(0)} EUR`;
    },

    // check if donation part is visible and count only once
    donationVisible(isVisible) {
      if(isVisible && !this.donationIsCounted) {
        this.donationsCount = this.donationsSum;
        this.donationIsCounted = true;
      }
    },

    // check if registration is visible and show corona special
    registrationVisible(isVisible) {
      setTimeout(() => this.showCoronaSpecial=true, 3500);
    }


  },

}
</script>

<style lang="scss" scoped>
  .phstart-search {
    background-image: url('/static/yummy.jpg');
    background-position: center center;
    background-size: cover;
    border-bottom: 10px solid #666;
    margin-bottom: 50px;

    @media (min-width: 992px) {
      padding-top: 120px;
      padding-bottom: 120px;
    }
  }

  .text-shadow {
    text-shadow: 2px 2px 5px #000;
  }

  h1 {
    @media (min-width: 992px) {
      font-size: 4rem;
    }
  }

  h3 {
    @media (min-width: 992px) {
      font-size: 1.5rem;
    }
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity .5s
  }


  .fade-enter,
  .fade-leave-to {
    opacity: 0
  }




</style>



// WEBPACK FOOTER //
// src/views/home/index-foodi.vue